define( function() {
	return ( /\S+/g );
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/rnotwhite.js
 ** module id = 852
 ** module chunks = 2
 **/